import { Icon28LogoVkColor } from '@vkontakte/icons';

import type { WidgetTheme } from '../../types/theme';

import { MaxIcon, SferumIcon } from '../../icons';

export const getWidgetLogoByTheme = (widgetTheme?: WidgetTheme) => {
  if (!widgetTheme) {
    return <Icon28LogoVkColor />;
  }

  return {
    default: <Icon28LogoVkColor />,
    spherum: <SferumIcon />,
    max: <MaxIcon />,
    postupai: <Icon28LogoVkColor />,
  }[widgetTheme];
};
